import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-modify-comment',
  templateUrl: './modify-comment.component.html',
  styleUrls: ['./modify-comment.component.scss']
})
export class ModifyCommentComponent {
  comment: string = '';
  confirmButtonText = "Yes";
  cancelButtonText = "No";
  defaultMessage: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialog: MatDialogRef<ModifyCommentComponent>
  ) {
    this.defaultMessage = data.defaultMessage;
  }

  onConfirmClick(): void {
    this.dialog.close({ 
      confirmed: true, 
      comment: this.comment.trim() 
    });
  }

  onCancelClick(): void {
    this.dialog.close({ confirmed: false });
  }
}